import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ThreadList } from '../../data-contract/chat';
import { useApplicationFetchers } from '../../fetchers/use-application-fetchers';
import { chatKeys } from './query-keys';

export const useChatThreads = (): UseQueryResult<ThreadList, Error> => {
    const { fetchChatThreads } = useApplicationFetchers();

    return useQuery({
        queryFn: async () => {
            const result = await fetchChatThreads();

            if (result.isErr === true) {
                throw result.error;
            }

            return result.value;
        },
        queryKey: chatKeys.threads(),
    });
};
